import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light bg-light" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "navbar-brand",
  href: "#"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarNav"
}
const _hoisted_6 = { class: "navbar-nav ms-auto" }
const _hoisted_7 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_8 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_9 = {
  key: 2,
  class: "nav-item"
}

import { useAuthStore } from '@/stores/authStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const logoSrc = require('@/assets/logo-cropped.webp');

const authStore = useAuthStore()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(logoSrc),
          alt: "Logo",
          class: "navbar-logo"
        }, null, 8, _hoisted_4)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarNav",
        "aria-controls": "navbarNav",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_unref(authStore).isAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/home"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("Home")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(authStore).isAuthenticated && _unref(authStore).isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/users"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("User Management")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(authStore).isAuthenticated)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/logout"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Logout")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})